/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "structure";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Category {
}

export enum Category_Enum {
  INVALID = 0,
  GENERIC = 1,
  TRANSMISSION_TOWER = 2,
  TRANSMISSION_INSULATOR = 3,
  PERSON = 4,
  VEHICLE = 5,
  WAREHOUSE_BAY = 6,
  UNRECOGNIZED = -1,
}

export function category_EnumFromJSON(object: any): Category_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return Category_Enum.INVALID;
    case 1:
    case "GENERIC":
      return Category_Enum.GENERIC;
    case 2:
    case "TRANSMISSION_TOWER":
      return Category_Enum.TRANSMISSION_TOWER;
    case 3:
    case "TRANSMISSION_INSULATOR":
      return Category_Enum.TRANSMISSION_INSULATOR;
    case 4:
    case "PERSON":
      return Category_Enum.PERSON;
    case 5:
    case "VEHICLE":
      return Category_Enum.VEHICLE;
    case 6:
    case "WAREHOUSE_BAY":
      return Category_Enum.WAREHOUSE_BAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Category_Enum.UNRECOGNIZED;
  }
}

export function category_EnumToJSON(object: Category_Enum): string {
  switch (object) {
    case Category_Enum.INVALID:
      return "INVALID";
    case Category_Enum.GENERIC:
      return "GENERIC";
    case Category_Enum.TRANSMISSION_TOWER:
      return "TRANSMISSION_TOWER";
    case Category_Enum.TRANSMISSION_INSULATOR:
      return "TRANSMISSION_INSULATOR";
    case Category_Enum.PERSON:
      return "PERSON";
    case Category_Enum.VEHICLE:
      return "VEHICLE";
    case Category_Enum.WAREHOUSE_BAY:
      return "WAREHOUSE_BAY";
    case Category_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseCategory(): Category {
  return {};
}

export const Category = {
  encode(_: Category, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Category {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Category {
    return {};
  },

  toJSON(_: Category): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Category>, I>>(base?: I): Category {
    return Category.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Category>, I>>(_: I): Category {
    const message = createBaseCategory();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
